import React from 'react'
import { useState,useEffect } from 'react';
import { Box} from '@mui/material';


import { stateValuesDos } from '../../../Utils/Utils';
import UpdateCompanyForm from '../../../Components/Companies/UpdateCompanyForm';
import DialogeConfirmationBox from '../../../Components/Companies/DialogeBoxes/DialogeConfirmationBox';
import LoadingBackDrop from '../../../Components/LoadingBackDrop';
import SnackBar from '../../../Components/SnackBar';

// import {mockBuildersDos, mockBuilders, findBuilder } from '../../Services/MockBuilderAPI';

import { getAllBuilderCompanies,patchBuilder } from '../../Services/BuilderAPI';



export default function UpdateBuilderAgencyForm() {

    var hqBusinessType = "Builder";
    let confirmationType = "Update";
    let titleAction = "Updating";


      
    const [companiesArray, setCompaniesArray] = useState([]);
    const [inputStateValue, setInputStateValue] = React.useState('');
    const [stateValue, setStateValue] = React.useState(null);
    const [viewCompanyField, setViewCompanyFields] = useState("none");
    const [confirmationDialogeBoxOpen, setConfirmationDialogeBoxOpen] = useState(false);
    const [openLoadingBackDrop, setOpenLoadingBackdrop] = useState(false);
  
    /**
     * SNACK BAR States
     */
    const[alertType,setAlertType] = useState("success");
    const[alertMessage, setAlertMessage]=useState("")
    const [snackBarOpen, setSnackBarOpen] = useState(false);

    
    const [companyObjct, setCompanyObjct] = useState({
        hq_id:"",
        hq_company_name:"",
        hq_company_type:"Builder",
        hq_company_address:{
            address:"",
            address_two:"",
            city:"",
            state:"",
            zip:""
        },
        hq_phone:"",
        hq_email:""
    });

    const[companyObjectBeforeUpdate, setCompanyObjectBeforeUpdate] = useState({
        hq_id:"",
        hq_company_name:"",
        hq_company_type:"Builder",
        hq_company_address:{
          address:"",
          address_two:"",
          city:"",
          state:"",
          zip:""
      },
        hq_phone:"",
        hq_email:""
    });

    const [errorObject,setErrorObject] = useState({
        hq_company_name:false,
        hq_company_type:"Bank",
        hq_company_address:{
          address:false,
          address_two:false,
          city:false,
          state:false,
          zip:false
      },
        hq_phone:false,
        hq_email:false
    
    });

    var initialCompanyObject = {
        hq_id:"",
        hq_company_name:"",
        hq_company_type:"Bank",
        hq_company_address:{
          address:"",
          address_two:"",
          city:"",
          state:"",
          zip:""
      },
        hq_phone:"",
        hq_email:""
    };

    function handleConfirmDialogeBoxClose(){
        setConfirmationDialogeBoxOpen(false);
      };
    
      function handleLoadingClose(){
        setOpenLoadingBackdrop(false);
      };

    /**
     * OPENS THE SNACKBAR
     */
    const handleSnackBarOpen = () => {
        setSnackBarOpen(true);
    };

    /**
     * CLOSES THE SNACK BAR
     */
    const handleSnackBarClosed = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarOpen(false);
    };

    useEffect(()=>{
        // get all the builders
        const fetchBuilders = async () => {
          const allBuildersData = await getAllBuilderCompanies();
          console.log(allBuildersData.data)
          setCompaniesArray(allBuildersData.data);
          return allBuildersData.data
        }
        fetchBuilders();
        
        
      
        // have state for loading of the banks -> use the mui loading thing
        // and set to state for loading and set the state for banks array
    
        // when a bank is added
          // check to see if it was successfully added
          // if added successfully
            // update the array state and add that bank
            // set the inputs to blank object
          // if not successfully added
            // do not clear form have the error show why it was not successfully added
    
    
    },[]);

    const findHqCompany = (hq_id) =>{
        let foundHq = companiesArray.filter((hq) => 
            hq.hq_id === hq_id
        );
        if (foundHq.length === 1){
            return foundHq[0];
        }else{
            return null;
        }
        
        // const result = words.filter((word) => word.length > 6);
    };

    function handleChoosenHQChange(e){

        let hq_id = e.target.value;
        let choosenHq = findHqCompany(hq_id);
    
        if(choosenHq){
            setViewCompanyFields("block");
            setCompanyObjct(choosenHq);
            setCompanyObjectBeforeUpdate(choosenHq);
            let hqAddressState = choosenHq.hq_company_address.state;
    
            let stateOpt = stateValuesDos.filter((opt) => 
                opt.index === hqAddressState
            );
    
            setStateValue(stateOpt[0]);
            setInputStateValue(stateOpt[0].index);
          
        }else{
            console.log("cant find");
            setViewCompanyFields("none");
            setCompanyObjct(initialCompanyObject);
            setCompanyObjectBeforeUpdate(initialCompanyObject);
        }
        
    };


      
    function handleNameChange(e){
        setCompanyObjct({
            ...companyObjct,
            hq_company_name: e.target.value
        });
    };
      
    function handleEmailChange(e){
    setCompanyObjct({
        ...companyObjct,
        hq_email: e.target.value
    });
    };
      
    function handlePhoneChange(e){
    setCompanyObjct({
        ...companyObjct,
        hq_phone: e.target.value
    });
    };
      
    function handleAddressChange(e){
    setCompanyObjct({
        ...companyObjct,
        hq_company_address:{
        ...companyObjct.hq_company_address,
        address:e.target.value
        }
    });
    };
    
    function handleAddressTwoChange(e){
        setCompanyObjct({
            ...companyObjct,
            hq_company_address:{
            ...companyObjct.hq_company_address,
            address_two:e.target.value
            }
        });
    };
    
    function handleCityChange(e){
        setCompanyObjct({
            ...companyObjct,
            hq_company_address:{
            ...companyObjct.hq_company_address,
            city:e.target.value
            }
        });
    };
    
    function handleStateChange(e){
        setCompanyObjct({
            ...companyObjct,
            hq_company_address:{
            ...companyObjct.hq_company_address,
            state:e.index
            }
        });
    };
    
    function handleZipChange(e){
        setCompanyObjct({
            ...companyObjct,
            hq_company_address:{
            ...companyObjct.hq_company_address,
            zip:e.target.value
            }
        });
    };


    /**
     * Error Validating The Form
    */
    function formErrorValidation(e){
        e.preventDefault();
        let foundError = false;

        if(companyObjct.hq_company_name === "" || companyObjct.hq_company_name === null ){
        setErrorObject({
            ...errorObject,
            hq_company_name:true
        });
        foundError = true;
        }



        if(!foundError){
        testConfirmAddCompanyConfirmationBox()
        }
    };

    /***
     * Handles the submit button from form component
     */
    function testConfirmAddCompanyConfirmationBox(){
        setConfirmationDialogeBoxOpen(true)
    }

    /***
     * Handles the response from the confirmation dialoge box
     */
    function dialogeConfirmationBoxAnswerHandle(resp){
        console.log("handling answer");
        console.log("The answer is === " + resp);
        if(resp === "Agree"){
        setConfirmationDialogeBoxOpen(false);
        setOpenLoadingBackdrop(true);
        submitUpdateHQBCompany();
        }else{
        setConfirmationDialogeBoxOpen(false);
        }
    };

    /**
     * Submits update to backend
     */
    async function submitUpdateHQBCompany(){
        let resp = await patchBuilder(companyObjct);
        setOpenLoadingBackdrop(false);
        if (resp.error){
        setAlertType("error");
        setAlertMessage(`There was an error ${confirmationType.toLowerCase()} the HQ ${hqBusinessType}.`);
        }else{
        setAlertType("success");
        setAlertMessage(`The HQ ${hqBusinessType} has been successfully ${confirmationType.toLowerCase()}ed.`);
        handleSnackBarOpen();
        addUpdatedItemToArray();
        clearForm();
        }
    };

    /**
     * Replaces the updated item with the newly updated item
     */
    function addUpdatedItemToArray(){
        let copiedCompaniesArray = [...companiesArray];
        let clonedCompany = {...companyObjct}
        const modifiedCompanies = copiedCompaniesArray.map(obj => {

        if (obj.hq_id === clonedCompany.hq_id) {
            console.log("found it");
            return clonedCompany;
        }
        return obj;
        });
        setCompaniesArray(modifiedCompanies);
    };

    /**
     * Resets the companyObject so the form is cleared.
     */
    function clearForm(){
        setCompanyObjct(initialCompanyObject);
    };
    

  return (
    <Box>
        <UpdateCompanyForm
            errorValidator={errorObject}
            addWhatCompanyTitle={hqBusinessType}
            hqCompaniesToMap = {companiesArray}
            hqCompanyObject={companyObjct}

            handleChoosenHQ = {handleChoosenHQChange} // HANDLES THE CHANGE OF THE SELECT HQ INPUT
            viewCompanyField={viewCompanyField}
            handleNameChange={handleNameChange}
            handleEmailChange={handleEmailChange}
            handlePhoneChange={handlePhoneChange}
            handleAddressChange={handleAddressChange}
            handleAddressTwoChange={handleAddressTwoChange}
            handleCityChange={handleCityChange}
            handleStateChange={handleStateChange}
            inputStateValue={inputStateValue}
            setInputStateValue={setInputStateValue}
            stateValue={stateValue}
            setStateValue={setStateValue}
            handleZipChange={handleZipChange}
            submitUpdateHqCompany={formErrorValidation}
      
        />
        <DialogeConfirmationBox
          confirmationType={confirmationType}
          titleAction={titleAction}
          intialUpdatedObject={companyObjectBeforeUpdate}
          updatedObject={companyObjct}

          addWhatCompanyType={hqBusinessType}
          hqCompanyObject={companyObjct}
          confirmationDialogeBoxOpen={confirmationDialogeBoxOpen}
          dialogeConfirmationBoxAnswerHandle={dialogeConfirmationBoxAnswerHandle}
          handleConfirmDialogeBoxClose={handleConfirmDialogeBoxClose}
        />
        <LoadingBackDrop
          openLoadingBackDrop={openLoadingBackDrop}
          handleLoadingClose={handleLoadingClose}
        />
        <SnackBar
          handleSanckBarOpen={handleSnackBarOpen}
          handleSnackBarClosed={handleSnackBarClosed}
          snackBarState = {snackBarOpen}
          alertType={alertType}
          alertMessage={alertMessage}
        />
       
    </Box>
  )
}



